import React from 'react';
import { Box, Typography, Tooltip } from '@mui/material';
import { lightColours } from '../../../../styles/colours';

export const DesktopTaxBrackets = ({
  bracketDetails,
  TAX_BANDS,
  darkMode,
  currentBracketIndex,
}) => {
  // Calculate total taxable income across all brackets
  const totalSalary = bracketDetails.reduce(
    (sum, { taxableAmount }) => sum + taxableAmount,
    0
  );

  return (
    <>
    {/* Heading for Tax Brackets */}
    <Typography
    variant="h6"
    sx={{ backgroundColor: 'white', pt:1, pb:1, textAlign: 'left', fontWeight: 'bold', color: darkMode ? '#fff' : '#222' }}
    >
    Tax Brackets
    </Typography>

    <Box
      sx={{
        display: 'flex',
        width: '100%',
        height: 80,
        backgroundColor: darkMode ? '#333' : lightColours.lightGrey,
        position: 'relative',
        transition: 'background-color 0.3s ease',
      }}
    >
      {bracketDetails.map(({ rate, taxableAmount, tax }, index) => {
        if (
          !TAX_BANDS[index] ||
          TAX_BANDS[index].min === undefined ||
          TAX_BANDS[index].max === undefined
        ) {
          console.error(`Invalid tax band at index ${index}:`, TAX_BANDS[index]);
          return null;
        }

        // Compute the bar's width as a percentage of the total taxable income
        const barPercentage =
          taxableAmount > 0 ? (taxableAmount / totalSalary) * 100 : 0;
        // Inner percentages computed relative to the bracket's taxableAmount
        const takeHomePercent =
          taxableAmount > 0 ? ((taxableAmount - tax) / taxableAmount) * 100 : 0;
        const taxPaidPercent =
          taxableAmount > 0 ? (tax / taxableAmount) * 100 : 0;

        return (
          <Box
            key={index}
            sx={{
              width: barPercentage > 100 ? '100%' : `${barPercentage}%`,
              position: 'relative',
              border: `2px solid ${darkMode ? '#444' : '#fff'}`,
              boxSizing: 'border-box',
              transition: 'border-color 0.3s ease',
            }}
          >
            <Box sx={{ display: 'flex', height: '100%' }}>
            <Tooltip
                title={`Take Home: £${(taxableAmount - tax).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                })}`}
                arrow
                >
                <Box
                    sx={{
                    backgroundColor: lightColours.midBlue,
                    width: `${takeHomePercent}%`,
                    height: '100%',
                    }}
                />
                </Tooltip>
                <Tooltip
                title={`Tax Paid: £${tax.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                })}`}
                arrow
                >
                <Box
                    sx={{
                    backgroundColor: lightColours.darkBlue,
                    width: `${taxPaidPercent}%`,
                    height: '100%',
                    }}
                />
                </Tooltip>

            </Box>
            {/* Only show the label if taxableAmount is greater than 0 */}
            {taxableAmount > 0 && (
              <Typography
                variant="caption"
                sx={{
                  position: 'absolute',
                  left: '50%',
                  width: '100%',
                  backgroundColor: darkMode
                    ? 'rgba(255,255,255,0.05)'
                    : 'rgba(0,0,0,0.05)',
                  borderColor: darkMode ? '#444' : '#fff',
                  transform: 'translateX(-50%)',
                  fontWeight: 'bold',
                  fontSize: '1rem',
                  color: darkMode ? '#fff' : '#222',
                  p: 0,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  opacity: index <= currentBracketIndex ? 1 : 0.3,
                }}
              >
                {rate === 0 ? '0%' : `${rate}%`}
              </Typography>
            )}
          </Box>
        );
      })}
    </Box>
  </>
  );
};
